import Request from './request'

const Device_Snapshot = {
  takeDeviceSnapshot (id, params, callback) {
    Request.post('device-snapshot/take/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceSnapshotsList(params, callback) {
    Request.get('device-snapshot/list', params).then(callback).catch(this.bad_answer)
  },
  getDeviceSnapshot (id, callback) {
    Request.get('device-snapshot/view/' + id).then(callback).catch(this.bad_answer)
  },
  getSnapshotList(params, callback) {
    Request.get('device-snapshot', params).then(callback).catch(this.bad_answer)
  },
  checkClientOrder(params, callback) {
    Request.post('device-snapshot/check-client-order', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  }
}
export default Device_Snapshot
